document.querySelectorAll('[data-contact-form]').forEach((form) => {
  const status = form.querySelector('[data-contact-form-status]');
  const submitButton = form.querySelector('[type="submit"]');

  if (!status || !submitButton) {
    return;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (!form.reportValidity()) {
      return;
    }

    submitButton.disabled = true;
    status.textContent = 'Nachricht wird gesendet …';

    try {
      const action = form.dataset.action || 'save_contact_form';
      const response = await fetch(`/api.php?action=${encodeURIComponent(action)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.fromEntries(new FormData(form))),
      });
      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || `Anfrage fehlgeschlagen (${response.status}).`);
      }

      status.textContent = data.message;
      form.reset();
    } catch (error) {
      console.error('Fehler beim Senden des Kontaktformulars:', error);
      status.textContent = error instanceof Error
        ? error.message
        : 'Die Nachricht konnte nicht gesendet werden. Bitte versuche es später erneut.';
    } finally {
      submitButton.disabled = false;
    }
  });
});
